
<div
  class="metric-card"
  :class="cardClasses"
  :style="highlightStyle"
  :aria-label="ariaLabel || `${title}: ${value}${subtitle ? ', ' + subtitle : ''}`"
  :data-testid="`metric-card-${sanitizedTitle}`"
  :role="clickable ? 'button' : 'region'"
  :tabindex="clickable ? 0 : undefined"
  @click="handleClick"
  @keydown.enter="handleClick"
  @keydown.space.prevent="handleClick"
>
  <div class="metric-card__content">
    <div class="metric-card__label" :class="labelClass">
      {{ title }}
    </div>
    <div class="metric-card__value" :class="valueClass">
      {{ value }}
    </div>
    <div v-if="subtitle" class="metric-card__subtitle" :class="subtitleClass">
      {{ subtitle }}
      <v-tooltip v-if="subtitleTooltip" bottom>
        <template #activator="{ on, attrs }">
          <v-icon
            x-small
            class="metric-card__subtitle-icon"
            tabindex="0"
            role="img"
            :aria-label="subtitleTooltip"
            v-bind="attrs"
            v-on="on"
          >
            mdi-information-outline
          </v-icon>
        </template>
        <span>{{ subtitleTooltip }}</span>
      </v-tooltip>
    </div>
  </div>
  <div v-if="icon" class="metric-card__icon">
    <v-icon
      size="24"
      :style="{ color: resolvedIconColor }"
      :aria-hidden="true"
    >
      {{ icon }}
    </v-icon>
  </div>
</div>
